<div class="palantir-tabs">
  <div class="palantir-tabs__buttons palantir-scrollbar">
    @for (step of steps; track step; let i = $index) {
      <button
        type="button"
        class="palantir-tabs__button"
        [class.palantir-tabs__button--active]="selectedIndex === i"
        [class.palantir-tabs__button--inactive]="!step.editable"
        (click)="step.select()"
      >
        <span>{{ step.label }}</span>
        <ng-container *ngTemplateOutlet="step.stepLabel?.template || null" />
      </button>
    }
  </div>

  @for (step of steps; track step; let i = $index) {
    <div
      class="palantir-tabs__tab"
      [class.palantir-tabs__tab--inactive]="selectedIndex !== i || !step.editable"
      [id]="_getStepContentId(i)"
      [@tabTransition]="{ value: getAnimationDirection(i) }"
    >
      <ng-container *ngTemplateOutlet="step.content" />
    </div>
  }
</div>
